import styled, { css } from 'styled-components';

export const SalesCategoryContainer = styled.div`
    width: fit-content;
    height: fit-content;
    display: flex;
    gap: 22px;
    @media (max-width: 768px) {
        gap: 12px;
    }
`;
export const CategoryButton = styled.button`
    font-weight: 600;
    font-size: 24px;
    line-height: 1.43;
    border: none;
    background-color: transparent;
    cursor: pointer;
    padding: 0;
    ${(props) =>
        props.$isSelected &&
        css`
            text-decoration: underline;
            text-underline-offset: 10px;
        `}
    @media (max-width: 768px) {
        font-size: 23px;
    }
`;
